import { createSlice } from '@reduxjs/toolkit'
import { roundToNearestMinutes } from 'date-fns'

/**
 * {
 *  info: {
 *    name: string;
 *    phone: string;
 *    startDate: number;
 *    endDate: number;
 *  }
 * 	location: {
 * 		county: string; //county name
 * 		coords: {longitude:number, latitude:number}
 * 	},
 * fuelLoad: {
 *    cropCategory: 'crop' | 'forestry',
*     cropType: string,
 *    fuelLoadingRange: // 0: Low, 1: Medium, 2: High
 *    totalAcres: number,
 *    totalTonnage: number
 * },
 * weather: {
 *  catDay: string,
 *  windSpeed: number,
 *  windDirection: number,
 *  humidity: number,
 * },
 * comments: string,
 * distToClosestSSA: number,
 * closestSSA: {
  * name: string,
  * type: string,
  * address: string
* },
  recommendation: {
    totalTonnageForThisBurn: number, // Burnsize * Available Fuels
    totalTonnageForAllBurns: number, //  Burnsize * Available Fuels + other planned burn tonnage
    allocatedTonnage: number, // Cat Day + Target distance = Allowed (from handbook table)
    totalAllowedTonnage: number, // allocatedTonnage - Total tonnage of other burns with the airshed 
    totalAllowedAcres: number,
    deniedReason: {
      tonsExceeded: boolean,
      badWeather: boolean
    }
  }
 * 
 * }
 */
const initialState = {
  info: {
    name: '',
    phoneNum: '',
    startDate: roundToNearestMinutes(new Date(), {nearestTo: 30}).getTime(),
    endDate: null,
  },
  location: null,
  fuelLoad: {
    cropCategory: '',
    cropType: null,
    // fuelLoadingRange: 0,
    fuelLoadingRange: -1,
    totalAcres: 0,
    totalTonnage: 0
  },
  weather: {
   catDay: "",
   windSpeed: 0,
   windDirection: 0,
   humidity: 0,
  },
  comments: '',
  distToClosestSSA: 0,
  closestSSA: {name:'', type: '', address: ''},
  recommendation: {
    totalTonnageForThisBurn: 0,
    totalTonnageForAllBurns: 0,
    allocatedTonnage: 0,
    totalAllowedTonnage: 0,
    totalAllowedAcres: 0,
    deniedReason: {
      tonsExceeded: false,
      badWeather: false
    }
  }
}

export const submissionSlice = createSlice({
  name: 'submission',
  initialState: {...initialState},
  reducers: {
    setInfo: (state, action) => {
	    state.info = action.payload
    },
    setLocation: (state, action) => {
	    state.location = action.payload
    },
    setFuelLoad: (state, action) => {
      state.fuelLoad = action.payload
    },
    setWeatherData: (state, action) => {
      state.weather = {...state.weather, ...action.payload}
    },
    setCategoryDay: (state, action) => {
      state.weather.catDay = action.payload;
    },
    setComments: (state, action) => {
      state.comments = action.payload;
    },
    setClosestSSA: (state, action) => {
      state.distToClosestSSA = action.payload.distance;
      state.closestSSA = action.payload.name;
    },
    setRecommendation: (state, action) => {
      state.recommendation = action.payload;
    },
    setRecommendationDenial: (state, action) => {
      state.recommendation.deniedReason = action.payload;
    },
    clearAll: (state, action) => {
      state.info = initialState.info;
      state.location = initialState.location;
      state.fuelLoad = initialState.fuelLoad;
      state.weather = initialState.weather;
      state.distToClosestSSA = initialState.distToClosestSSA;
      state.recommendation = initialState.recommendation;
      state.comments = initialState.comments;
    },
  },
})

export const { 
  setInfo,
  setLocation,
  setFuelLoad,
  setWeatherData,
  setCategoryDay,
  setComments,
  setClosestSSA,
  setRecommendation,
  setRecommendationDenial,
  clearAll
} = submissionSlice.actions

export default submissionSlice.reducer